import { FtuePreference } from "./types";

const MALE_IMAGE = "/images/male.png";
const FEMALE_IMAGE = "/images/female.png";
const NON_BINARY_IMAGE = "/images/nonBinary.png";

export const preferenceOptions = [
  { key: FtuePreference.FEMALE, image: FEMALE_IMAGE, label: "Female" },
  { key: FtuePreference.MALE, image: MALE_IMAGE, label: "Male" },
  { key: FtuePreference.NON_BINARY, image: NON_BINARY_IMAGE, label: "Non-Binary" },
];

export const FTUE_MODAL_DELAY = 3000;

export const FTUE_PENDING_DISPLAY_SESSION_STORAGE_KEY = "ftuePendingDisplay";
